import React, { createContext, useMemo, useState } from 'react';
import { FullPageLoader } from 'common';
import { isAuthenticated } from 'services/Authentication';

import { useLogRocket, useUserData } from './UserProvider.hooks';

export const UserProviderContext = createContext();

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const isLoggedIn = useMemo(() => !!user || isAuthenticated(), [user]);

  useLogRocket({ user });

  const { isResolvingUser } = useUserData({ isLoggedIn, onResolveUser: setUser });

  const getChildren = () => (!isLoggedIn || user ? children : null);

  const value = useMemo(() => [user, setUser], [user]);

  return (
    <UserProviderContext.Provider value={value}>
      {isResolvingUser ? <FullPageLoader /> : getChildren()}
    </UserProviderContext.Provider>
  );
};

export const useUserContext = () => {
  const context = React.useContext(UserProviderContext);
  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};

export default UserProvider;
